<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin">
                <span class="loader">
                    <span>{{ $spinnerText }}</span>
                </span>
            </div>
        </Transition>

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :showModeOpenId="showModeOpenId"
                :viewParams="viewParams"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <OrderForm :formProps="formProps">
                </OrderForm>
            </template>
            <template #search="searchProps">
                <OrderSearch :searchProps="searchProps">
                </OrderSearch>
            </template>

            <template #buttons>
                <BackButton v-if="showReturnToOfferProductsButton"
                            :backFunction="goToOfferProducts" />
            </template>

        </v-view>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { router } from '@inertiajs/vue3'
import OrderForm from './OrderForm.vue'
import OrderSearch from './OrderSearch.vue'
import BackButton from '@crud/BackButton.vue'
import { __, getFromUrl, screenMessage, getFromRoute, printReport } from '@pages/Helper/utils.js';

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    viewParams: Object,
})

const selectedRows = ref([])
const showModeOpenId = getFromUrl()
const isBackButtonVisible = ref(false)
const isCreateQuotationModalOpen = ref(false)
const formPropsToPass = ref(null)
const isLoading = ref(false)
const showReturnToOfferProductsButton = ref(false)
const dialogPt = {
    header: { class: 'form-header' },
    content: { class: 'form-body' },
};

if (props.viewParams?.product_id) {
    showReturnToOfferProductsButton.value = true
}
//------------------------------------------------------------------------------

onMounted(() => {
    if (props.viewParams.opportunity_id) {
        isBackButtonVisible.value = true
    }
})

//------------------------------------------------------------------------------

const goToOfferProducts = () => {
    router.visit(route('offerproduct-index'), {
        onError: (errors) => {
            const message = errors?.error ?? 'Wystąpił nieznany błąd'
            screenMessage({ type: 'error', title: __('Error'), message: message });
        }
    })
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
